
<div class="frontpage-widget cover-image-trees-gray">
  <div class="whitebox dark-blue">
    <div class="container">
      <h2 class="nav-link" (click)="goHome()">Lokaliteten er fjernet fra Screeningen og kan ikke ses. Tryk her for at komme til forsiden af Grundrisk.</h2>
    </div>
  </div>
</div>